import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';

// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Injectable()
export class TranslatorService {

  private defaultLanguage = 'it';
  private languageSelected: string = this.defaultLanguage;

  private availablelangs: any[] = [
    {code: 'en', text: 'English'},
    {code: 'it', text: 'Italian'}
  ];

  constructor(public translate: TranslateService) {
    if (!translate.getDefaultLang()) {
      translate.setDefaultLang(this.defaultLanguage);
    }
    this.useLanguage();
  }

  useLanguage(lang: string = ''): void {
    if (!this.inAvailableLanguages(lang)) {
      lang = '';
    }
    this.languageSelected = lang;
    this.translate.use(lang || this.translate.getDefaultLang());
  }

  inAvailableLanguages(lang: string): boolean {
    let isInAvailableLanguages = false;
    this.availablelangs.forEach(language => {
      if (language.code === lang) {
        isInAvailableLanguages = true;
      }
    });
    return isInAvailableLanguages;
  }

  getAvailableLanguages(): any[] {
    return this.availablelangs;
  }

  getLanguageSelected(): string {
    return this.languageSelected;
  }

}
